import React from 'react';
export function Disclaimer() {
  return <section aria-labelledby="disclaimer-title" className="mx-auto w-full max-w-4xl px-4 pb-16 sm:px-6 lg:px-8" data-id="element-37" data-mp="2374sc4xn902p">
      <div className="border-t border-stone-200 pt-8" data-id="element-38" data-mp="3crheij05ov2m">
        <h2 id="disclaimer-title" className="text-sm font-semibold text-stone-900" data-id="element-39" data-mp="2xxcs4ow56r2m">
          Educational and product information
        </h2>
        <div className="mt-3 space-y-3 text-xs leading-relaxed text-stone-500 md:text-sm" data-id="element-40" data-mp="32x7jsunqrkoq">
          <p data-id="element-41" data-mp="3qn1v37sex16v">
            This guide is an educational and informational resource about the traditional Bach Flower framework and
            practice organization. It does not provide medical, mental-health, diagnostic, treatment, crisis-assessment,
            triage, or emergency-response advice. It does not claim that Bach Flower remedies diagnose, treat, cure, or
            prevent any condition, and it does not guarantee health, client, or business outcomes.
          </p>
          <p data-id="element-42" data-mp="i6qchfoqmh9z">
            For health concerns, seek advice from a qualified healthcare professional. For urgent safety concerns,
            contact appropriate local emergency or crisis services. Do not delay qualified care to use this resource.
          </p>
          <p data-id="element-43" data-mp="opn8659awdki">
            The Topical Guide is limited to label and product literacy; follow the exact manufacturer label and
            applicable local requirements. The Business Masterclass is educational and does not provide legal, tax,
            accounting, financial, or professional-scope advice.
          </p>
        </div>
      </div>
    </section>;
}